import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { DocumentaryReviewController } from '@shared/src/controllers/documentaryreview/documentaryreview.controller';
import { HomeController } from '@shared/src/controllers/home/home.controller';
import { ManagementModelController } from '@shared/src/controllers/managementmodel/managementmodel.controller';
import { HLong } from '@shared/src/datatypes/HLong';
import { DocumentaryReviewObjectBaseDto } from '@shared/src/dtos/documentaryreview/DocumentaryReviewObjectBaseDto';
import { ShipmentsDocumentaryReviewObjectBaseDto } from '@shared/src/dtos/documentaryreview/ShipmentsDocumentaryReviewObjectBaseDto';
import { ActionDto } from '@shared/src/dtos/maintenance/action/actionDto';

@Component({
  selector: 'shared-documentaryreview-route-item',
  templateUrl: './shared.documentaryreview.route.item.component.html',
  styleUrls: ['./shared.documentaryreview.route.item.component.scss'],
})
export class SharedDocumentaryReviewRouteItemComponent {

  public useIonic: boolean = false;

  constructor(@Inject('HomeController') public homeController: HomeController,
    private documentaryReviewController: DocumentaryReviewController) {

    if (homeController.useIonic)
      this.useIonic = homeController.useIonic();
  }

  @Input() public readonly: boolean = false;

  @Input() public showbuttonback: boolean = false;

  public __phaseId: number;
  @Input()
  set phaseId(value: number) {
    if (this.__phaseId === value)
      return;
    this.__phaseId = value;
    this.__shipmentsDReviewObject = null;
    this.loadData(false);
  }
  get phaseId(): number {
    return this.__phaseId;
  }

  public __routeId: number;
  @Input()
  set routeId(value: number) {
    if (this.__routeId === value)
      return;
    this.__routeId = value;
    this.__shipmentsDReviewObject = null;
    this.loadData(false);
  }
  get routeId(): number {
    return this.__routeId;
  }

  public __shipmentsDReviewObject: ShipmentsDocumentaryReviewObjectBaseDto;
  set shipmentsDReviewObject(value: ShipmentsDocumentaryReviewObjectBaseDto) {
    if (this.__shipmentsDReviewObject === value)
      return;
    this.__shipmentsDReviewObject = value;
  }
  get shipmentsDReviewObject(): ShipmentsDocumentaryReviewObjectBaseDto {
    return this.__shipmentsDReviewObject;
  }

  
  public __dReviewObject: DocumentaryReviewObjectBaseDto;
  set dReviewObject(value: DocumentaryReviewObjectBaseDto) {
    if (this.__dReviewObject === value)
      return;
    this.__dReviewObject = value;
  }
  get dReviewObject(): DocumentaryReviewObjectBaseDto {
    return this.__dReviewObject;
  }

  getResourceFirstTab(){
    if(!HLong.isNullOrNullLong(this.phaseId))
      return 'DOCUMENTARYREVIEW.PHASE.TAB';
    return 'DOCUMENTARYREVIEW.ROUTE.TAB';
  }

  @Output() routeRefresh: EventEmitter<number> = new EventEmitter();
  public loadData(dataupdate: boolean) {
    if(!HLong.isNullOrNullLong(this.phaseId)){
      if(HLong.isNullOrNullLong(this.routeId))
        return;
      if (HLong.isNullOrNullLong(this.selectedShipmentId)) {
        this.documentaryReviewController.getRoutePhaseDocumentaryReview(this.routeId, this.phaseId).subscribe(data => {
          this.shipmentsDReviewObject = data;
          this.dReviewObject = data;
          if (this.shipmentsDReviewObject && dataupdate)
            this.routeRefresh.next(this.routeId);
        });
      } else {
        this.documentaryReviewController.getRoutePhaseShipmentDocumentaryReview(this.routeId, this.phaseId, this.selectedShipmentId).subscribe(data => {
          this.dReviewObject = data;
        });
      }
    } else if (!HLong.isNullOrNullLong(this.routeId)) {
      if (HLong.isNullOrNullLong(this.selectedShipmentId)) {
        this.documentaryReviewController.getRouteDocumentaryReview(this.routeId).subscribe(data => {
          this.shipmentsDReviewObject = data;
          this.dReviewObject = data;
          if (this.shipmentsDReviewObject && dataupdate)
            this.routeRefresh.next(this.routeId);

        });
      } else {
        this.documentaryReviewController.getRouteShipmentDocumentaryReview(this.routeId, this.selectedShipmentId).subscribe(data => {
          this.dReviewObject = data;
        });
      }
    }
  }

  public onDataRefresh(value: boolean) {
    if (!value)
      return;

    this.loadData(true);
  }

  @Output() clickBack: EventEmitter<boolean> = new EventEmitter();
  onClickBack(event) {
    this.clickBack.next(true);
  }

  public __selectedShipmentId: number = 0;
  set selectedShipmentId(value: number) {
    if (this.__selectedShipmentId === value)
      return;
    this.__selectedShipmentId = value;
    this.loadData(true);
  }
  get selectedShipmentId(): number {
    return this.__selectedShipmentId;
  }
  selectShipment(shipmentId: number) {
    this.selectedShipmentId = shipmentId;
  }

  selectRoute() {
    this.dReviewObject = this.shipmentsDReviewObject;
    this.selectedShipmentId = 0;
  }

}
